import { IconProps } from "@/components/shared/Icon"
import { FacilityDetails } from "@/types/facility"
import { LevelConfigurationItemMode } from "@/types/levelConfiguration"

type LocationItem = {
   iconName: IconProps["name"]
   name: string
}

type Level = FacilityDetails["levels"][number]
type LevelById = Record<string, Level>

const extractParents = (levelById: LevelById, parentIds: string[]): Level[] =>
   parentIds.flatMap((parentId) => {
      const parent = levelById[parentId]
      if (!parent) return []
      return [
         ...extractParents(levelById, parent.parents),
         ...(parent.type.mode === LevelConfigurationItemMode.PHYSICAL
            ? [parent]
            : []),
      ]
   })

export const getLocationItems = (
   anchorMac: string | undefined,
   levels: FacilityDetails["levels"] | undefined
): LocationItem[] => {
   if (!anchorMac || !levels) return []

   const levelById: LevelById = Object.fromEntries(levels.map((l) => [l.id, l]))

   const virtualLevel = levels.find((level) =>
      level.sensors.some(
         (sensor) => sensor.macAddress.toLowerCase() === anchorMac.toLowerCase()
      )
   )
   if (!virtualLevel) return []

   return [
      ...extractParents(levelById, virtualLevel.parents).map((level) => ({
         iconName: level.type.icon as IconProps["name"],
         name: level.name,
      })),
      { iconName: "location" as IconProps["name"], name: virtualLevel.name },
   ]
}
